import { TWEnvType } from '../helpers/environment';

const dev = 'sdk-JkRmJv7CRLqEnzCk';

export const clientKeys: Record<TWEnvType, string> = {
  dev,
  staging: 'sdk-lccjVLdgXOz08Vvr',
  prod: 'sdk-ZyNap6Hy3IEeocf',
  unknown: dev,
};
